import type { User } from '@img-arena/consoles-api-streaming'

import { ActionDeleteItem } from '../ActionDeleteItem/ActionDeleteItem'

interface ActionDeleteStreamingUserItemProps {
  onDelete: (row: User) => Promise<void> | void
}

export const ActionDeleteStreamingUserItem = ({ onDelete }: ActionDeleteStreamingUserItemProps) => (
  <ActionDeleteItem
    onDelete={onDelete}
    displaySeparately
    successMessage={(row) => `User ${row.fullName} deleted successfully`}
    errorMessage={(row) => `Failed to delete user ${row.fullName}`}
    confirmationMessage={(row) => `Are you sure you want to delete user ${row.fullName}?`}
  />
)
